import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Stack,
} from '@mui/material';

interface UnsavedChangesDialogProps {
  open: boolean;
  onDiscard: () => void;
  onKeepEditing: () => void;
  title?: string;
  message?: string;
}

const UnsavedChangesDialog = React.memo(function UnsavedChangesDialog({
  open,
  onDiscard,
  onKeepEditing,
  title = 'Unsaved Changes',
  message = 'You have unsaved changes. Are you sure you want to leave? Your changes will be lost.',
}: UnsavedChangesDialogProps) {
  const handleClose = (_event: object, _reason: 'backdropClick' | 'escapeKeyDown') => {
    onKeepEditing();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700, color: 'text.primary', pb: 1 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: 'text.secondary' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Stack direction="row" spacing={1.5} sx={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            onClick={onKeepEditing}
            sx={{ color: 'text.secondary', borderColor: 'divider' }}
          >
            Keep Editing
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onDiscard}
          >
            Discard Changes
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
});

export default UnsavedChangesDialog;
